import { DateTime } from 'luxon'
import type { TicketSummary } from '../lib/types'
import { TicketItem } from './TicketItem'

// ── Table ─────────────────────────────────────────────────────────────────────

interface TicketTableProps {
  tickets: TicketSummary[]
  onSend?: (message: string) => void
}

export const TicketTable = ({ tickets, onSend }: TicketTableProps) => {
  if (tickets.length === 0) return null

  const sorted = [...tickets].sort(
    (a, b) =>
      DateTime.fromISO(b.updatedAt).toMillis() -
      DateTime.fromISO(a.updatedAt).toMillis()
  )

  return (
    <div className="my-2 flex flex-col gap-2.5">
      {sorted.map((ticket) => (
        <TicketItem key={ticket.ticketId} ticket={ticket} onSend={onSend} />
      ))}
    </div>
  )
}
